import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { OrderService } from 'src/app/services/api/order.service';
import { AddressesAndFormFieldComponent } from '../../addresses-and-form-field/addresses-and-form-field.component';
import { ToastService } from 'src/app/services/toast.service';
import { LangService } from 'src/app/services/lang/lang.service';


@Component({
	selector: 'app-changeorderrequest',
	templateUrl: './changeorderrequest.component.html',
	styleUrls: ['./changeorderrequest.component.scss']
})
export class ChangeorderrequestComponent implements AfterViewInit  {

	@ViewChild(AddressesAndFormFieldComponent, { static: false })
    addressesAndFormFieldComponent: AddressesAndFormFieldComponent;

	order: any = null;

	toggleModels: any = {
		addresses: false,
		shippingMethods: false,
		cancelOrder: false,
		isAgreed: false
	}

	selected:any = {
		address: null,
		shipping_method: null,
		branch_of_pickup: ''
	};

	isAddresChanged: boolean = false;
	isShippingMethodChanged: boolean = false;

	shippingMethodInputModel: string = '';
	shippingMethods: any = null;

	cancelReasonForm: any = null;
	changeOrderFee: number = 0;
	additionalShipingFee: number = 0;
	refundToWallet: number = 0;
	totalToBePaid: number = 0;

	checkoutBranchOfPickupModal: any = null;

	selectedAddressChangeCallback:any = null;

	onConfirm: any;
	onClose: any;

	isSubmitting: boolean = false;

	constructor(
		public orderService: OrderService,
		public toastService: ToastService,
		public langService: LangService,
	) { }

	ngAfterViewInit() {
		this.selectedAddressChangeCallback = (data:any) => {
			let add = this.order.addresses.find((a:any) => a.address_type === "shipping");
			this.selected.address = data;
			this.isAddresChanged = (this.selected.address.id != parseInt(add.customer_address_id));

			this.toggleModels.shippingMethods = true;
			this.getShippingMethods();
		}
    }

	setToggle($e: any, type:string){
		this.toggleModels[type] = $e.target.checked;
		if(type == 'addresses'){
			this.toggleModels.cancelOrder = false;
			
			let checkAddressesAndFormFieldComponent = setInterval(() => {
				if(typeof this.addressesAndFormFieldComponent != 'undefined'){
					let orderAddress = this.getAddressData(true);
					let addresses = this.addressesAndFormFieldComponent.customerService.customer.addresses;

					addresses.forEach((addresse:any) => {
						if(addresse.id == orderAddress.id){
							addresse.default_shipping = true;
						}
						else {
							addresse.default_shipping = false;
						}
					});

					clearInterval(checkAddressesAndFormFieldComponent);
				}
			}, 10);
		}
		else if(type == 'shippingMethods'){
			this.toggleModels.cancelOrder = false;
			if($e.target.checked){
				this.getShippingMethods();
			}
			else {
				// this.shippingMethods = null;
			}
		}
	}

	getAddressData(isStreetArray:boolean = false){
		let add = this.order.addresses.find((a:any) => a.address_type === "shipping");

		let s = this.selected.address ? this.selected.address.street : add.street;
		if(isStreetArray){
			s = [s];
		}

		return {
			"id": parseInt(this.selected.address ? this.selected.address.entity_id : add.customer_address_id),
			"customer_id": this.order.customer_id,
			"firstname": this.selected.address ? this.selected.address.firstname : add.firstname,
			"lastname": this.selected.address ? this.selected.address.lastname : add.lastname,
			"street": s,
			"city": this.selected.address ? this.selected.address.city : add.city,
			"country_id": this.selected.address ? this.selected.address.country_id : add.country_id,
			"region": { 
				"region": this.selected.address ? this.selected.address.region.region : add.region, 
				"region_id": parseInt(this.selected.address ? this.selected.address.region_id : add.region_id)
			},
			"region_id": parseInt(this.selected.address ? this.selected.address.region_id : add.region_id),
			"postcode": "",
			"telephone": this.selected.address ? this.selected.address.telephone : add.telephone,
			"telephone_secondary": this.selected.address ? this.selected.address.telephone_secondary : (add.telephone_secondary ? add.telephone_secondary : ''),
			"fax": "",
			"save_in_address_book": 0
		}
	}
				
	getShippingAddressJsonData(){
		var items:any = [];
		this.order.items.forEach((item:any) => {
			if(item.product){
				items.push({
					"product_id": item.product.id,  /** this should be the id of the child product and not the configurable product */
					"qty": parseInt(item.qty_ordered),
					"quote_item_id": item.quote_item_id
				});
			}
		});

		let add = this.order.addresses.find((a:any) => a.address_type === "shipping");

		return {
			"currency_id": this.order.store_currency_code,
			"email": this.order.billing_address.email,
			"shipping_address": this.getAddressData(),
			"quote_id": this.order.quote_id,
			"items": items,
			"coords": { 
				"lat": this.selected.address ? this.selected.address.extension_attributes.lat : add.lat, 
				"lng": this.selected.address ? this.selected.address.extension_attributes.lng : add.lng 
			}
		}
	}
	getShippingMethods(){
		this.toggleModels.shippingMethods = true;
		let jsonData = this.getShippingAddressJsonData();
		let url = this.orderService.getStoreUrl("/V1/hnd-wallet/carts/estimate-shipping-methods");

		this.orderService.post(url, JSON.stringify(jsonData), {
			"Content-Type": 'application/json'
		}).subscribe(result => {
			this.shippingMethods = result;
		}, error => {
			console.log('getShippingMethods getShippingMethods error', error)
		});
	}
	setShippingAndBilling(method:any){
		this.selected.shipping_method = method;
		this.shippingMethodInputModel = method.carrier_code;

		var methodCode = method.carrier_code + '_' + method.method_code;
		if(methodCode == this.order.shipping_method){
			this.isShippingMethodChanged = false;
		}
		else {
			this.isShippingMethodChanged = true;
		}

		var orderShippingAmount = parseFloat(this.order.shipping_amount);
		var methodShippingAmount = parseFloat(method.amount);
		if(orderShippingAmount > methodShippingAmount){
			this.additionalShipingFee = 0;
			this.refundToWallet = orderShippingAmount - methodShippingAmount;
		} 
		else {
			this.additionalShipingFee = methodShippingAmount - orderShippingAmount;
			this.refundToWallet = 0;
		}
	}
	get getTotalToBePaid(){
		this.totalToBePaid = this.changeOrderFee + this.additionalShipingFee;
		return this.totalToBePaid;
	}
	get isActiveAllFalse(){
		let allFalse = Object.keys(this.toggleModels).every(k => { 
			return this.toggleModels[k] === false; 
		});
		return allFalse;
	}
	get canSubmitRequest(){
		if(!this.isActiveAllFalse){
			if(this.toggleModels.isAgreed){
				if(this.toggleModels.cancelOrder){
					return this.cancelReasonForm.is_valid;
				} else {
					if(this.toggleModels.addresses && !this.toggleModels.shippingMethods){
						return this.isAddresChanged;
					}
					else if(!this.toggleModels.addresses && this.toggleModels.shippingMethods){
						return this.isShippingMethodChanged;
					}
					else if(this.toggleModels.addresses && this.toggleModels.shippingMethods){
						if(this.isAddresChanged){
							return this.selected.shipping_method == null ? false : true;
						}
						else if(this.isShippingMethodChanged){
							return true;
						}
						else {
							return false;
						}
					}
					else {
						return false;
					}
				}
			} else {
				return false;
			}
		}
		else {
			return false;
		}
	}
	submitRequest(){
		if(this.canSubmitRequest && !this.isSubmitting){
			this.isSubmitting = true;
			var sa:any = this.getShippingAddressJsonData();
			sa.shipping_address['lat'] = sa.coords.lat;
			sa.shipping_address['lng'] = sa.coords.lng;

			var address = {
				"id": sa.shipping_address.id,
				"customer_id": sa.shipping_address.customer_id,
				"region": { 
					"region_code": null, 
					"region": sa.shipping_address.region.region, 
					"region_id": sa.shipping_address.region.region_id 
				},
				"region_id": sa.shipping_address.region.region_id,
				"country_id": sa.shipping_address.country_id,
				"street":  Array.isArray(sa.shipping_address.street) ? sa.shipping_address.street : [sa.shipping_address.street],
				"telephone": sa.shipping_address.telephone,
				"city": sa.shipping_address.city,
				"firstname": sa.shipping_address.firstname,
				"lastname": sa.shipping_address.lastname,
				"middlename": "",
				"prefix": "",
				"default_shipping": false,
				"default_billing": false,
				"lat": sa.shipping_address.lat,
				"lng": sa.shipping_address.lng,
				"telephone_secondary": sa.telephone_secondary
			}

			var jsonData = {
				order_id: this.order.entity_id,
				address: address,
				shipping_method: this.selected.shipping_method,
				actions: this.toggleModels
			}
			// jsonData.actions['cancel_reason'] = this.cancelReasonForm.value.reason;
			jsonData.actions['cancel_reason'] = "";

			// if(this.selected.branch_of_pickup != ''){
			// 	jsonData.actions['branch_of_pickup'] = this.selected.branch_of_pickup;
			// }
			
			let url = this.orderService.getStoreUrl("/V1/hnd-wallet/order/change/request");
			this.orderService.doRequest(url, jsonData, "POST")
			.then((res:any) => {
				this.isSubmitting = false;
				this.toastService.add(this.langService.getLang('l110a'), 'success');
				if (this.onConfirm) {
					this.onConfirm();
				}
			})
			.catch((error:any) => {
				this.isSubmitting = false;
				this.toastService.add(this.langService.getLang('l111a'), 'danger');
				if (this.onClose) {
					this.onClose();
				}
			});


			// $.ajax({
			// 	type: "POST",
			// 	url: MAGE_STORE_URL + "/V1/hnd-wallet/order/change/request",
			// 	contentType: "application/json; charset=utf-8",
			// 	dataType: "json",
			// 	data: JSON.stringify(jsonData),
			// 	headers: {
			// 		Authorization: 'Bearer ' + MAGE_TOKEN
			// 	},
			// 	beforeSend: () => {
			// 		$('#loader-wrapper').removeClass('d-none');
			// 	},
			// 	success: (data) => {
			// 		window.vueapps.toast._data.add('The request to change the order was successfully saved. The order was put on hold to process your request.', 'success');
			// 		window.location.reload();
			// 	},
			// 	error: function(error) {
			// 		window.vueapps.toast._data.add(error.responseJSON.message, 'danger');
			// 		$('#loader-wrapper').addClass('d-none');
			// 	}
			// });
		}
	}
}
